import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from 'react';

export type ThemePreference = 'light' | 'dark';

const STORAGE_KEY = 'themePreference';

interface ThemePreferenceContextData {
    themePreference: ThemePreference;
    setThemePreference: (preference: ThemePreference) => void;
}

const ThemePreferenceContext = createContext<ThemePreferenceContextData>({
    themePreference: 'light',
    setThemePreference: () => {},
});

function readInitialPreference(): ThemePreference {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'dark' ? 'dark' : 'light';
}

export const ThemePreferenceProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const [themePreference, setThemePreference] = useState<ThemePreference>(readInitialPreference);

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, themePreference);
    }, [themePreference]);

    return (
        <ThemePreferenceContext.Provider value={{ themePreference, setThemePreference }}>
            {children}
        </ThemePreferenceContext.Provider>
    );
};

export function useThemePreference() {
    return useContext(ThemePreferenceContext);
}
